<template>
  <section id="dashboard-ecommerce">
    <b-row class="match-height">
      <b-col xl="6" md="6">
        <ecommerce-statistics
          :data="data.statisticsUsers"
          name="Utilisateurs"
        />
      </b-col>
      <b-col xl="6" md="6">
        <ecommerce-statistics :data="data.statisticsProducts" name="Produits" />
      </b-col>
      <b-col xl="6" md="6">
        <ecommerce-statistics :data="data.statisticsSales" name="Ventes" />
      </b-col>
      <b-col xl="6" md="6">
        <ecommerce-statistics :data="data.statisticsShop" name="Achats" />
      </b-col>
    </b-row>

    <b-row class="match-height">

      <!-- Revenue Report Card -->
      <!-- <b-col lg="12">
        <ecommerce-revenue-report :data="data.revenue" />
      </b-col> -->
      <!--/ Revenue Report Card -->


         <b-col lg="2">
        <b-row class="match-height">
          <!-- Bar Chart - Orders -->
          <b-col lg="12" md="12" cols="12">
            <ecommerce-order-chart :data="data.statisticsOrderEarning" name="Dépense"/>
          </b-col>
          <!--/ Bar Chart - Orders -->
          <b-col lg="12" md="12" cols="12">
            <ecommerce-order-chart :data="data.statisticsOrderExpense" name="Revenus"/>
          </b-col>
        </b-row>
      </b-col>
      <!-- Revenue Report Card -->
      <b-col lg="10">
        <ecommerce-revenue-report :data="data.revenue" />
      </b-col>
    </b-row>

    <b-row class="match-height">
      <!-- Company Table Card -->
      <!-- <b-col lg="12">
        <ecommerce-company-table :table-data="data.companyTable" />
      </b-col> -->
      <!--/ Company Table Card -->
      <b-col lg="12">
        <l-map
          :zoom="zoom"
          :center="center"
          style="overflow: hidden !important"
        >
          <l-tile-layer :url="url" />
        </l-map>
      </b-col>
    </b-row>
  </section>
</template>

<script>
import { BRow, BCol } from "bootstrap-vue";

import { getUserData } from "@/auth/utils";
import EcommerceStatistics from "./EcommerceStatistics.vue";
import EcommerceRevenueReport from "./EcommerceRevenueReport.vue";
import EcommerceOrderChart from "./EcommerceOrderChart.vue";
import EcommerceEarningsChart from "./EcommerceEarningsChart.vue";
import { LMap, LTileLayer, LMarker, LPopup } from "vue2-leaflet";
import axios from "axios";

export default {
  components: {
    BRow,
    BCol,
    LMap,
    LTileLayer,
    LMarker,
    LPopup,
    // EcommerceMedal,
    EcommerceStatistics,
    EcommerceRevenueReport,
    EcommerceOrderChart,
    // EcommerceProfitChart,
    EcommerceEarningsChart,
    // EcommerceCompanyTable,
    // EcommerceMeetup,
    // EcommerceBrowserStates,
    // EcommerceGoalOverview,
    // EcommerceTransactions,
  },
  data() {
    return {
      url: "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png",
      zoom: 8,
      center: [47.31322, -1.319482],
      markerLatLng: [47.31322, -1.319482, { draggable: "true" }],
      data: {
        statisticsUsers: [
          {
            icon: "UserXIcon",
            color: "light-info",
            title: "0",
            subtitle: "Prospect",
            customClass: "mb-2 mb-xl-0",
          },
          {
            icon: "UserPlusIcon",
            color: "light-success",
            title: "0",
            subtitle: "Clients",
            customClass: "mb-2 mb-sm-0",
          },
          {
            icon: "UserCheckIcon",
            color: "light-success",
            title: "0",
            subtitle: "Fournisseur",
            customClass: "",
          },
        ],
        statisticsProducts: [
          {
            icon: "DatabaseIcon",
            color: "light-info",
            title: "0",
            subtitle: "Produit",
            customClass: "mb-2 mb-xl-0",
          },
          {
            icon: "ClipboardIcon",
            color: "light-success",
            title: "0",
            subtitle: "Catégories",
            customClass: "mb-2 mb-sm-0",
          },
          {
            icon: "ClipboardIcon",
            color: "light-success",
            title: "0",
            subtitle: "Sous catégories",
            customClass: "",
          },
        ],
        statisticsSales: [
          {
            icon: "FileIcon",
            color: "light-info",
            title: "0",
            subtitle: "Devis",
            customClass: "mb-2 mb-xl-0",
          },
          {
            icon: "EditIcon",
            color: "light-info",
            title: "0",
            subtitle: "Commande",
            customClass: "mb-2 mb-sm-0",
          },
          {
            icon: "FileTextIcon",
            color: "light-success",
            title: "0",
            subtitle: "Facture",
            customClass: "",
          },
        ],
        statisticsShop: [
          {
            icon: "FileIcon",
            color: "light-info",
            title: "0",
            subtitle: "Devis",
            customClass: "mb-2 mb-xl-0",
          },
          {
            icon: "EditIcon",
            color: "light-info",
            title: "0",
            subtitle: "Commande",
            customClass: "mb-2 mb-sm-0",
          },
          {
            icon: "FileTextIcon",
            color: "light-success",
            title: "0",
            subtitle: "Facture",
            customClass: "",
          },
        ],
        statisticsOrderEarning: {
          series: [
            {
              name: new Date().getFullYear(),
              total: "00.000",
              data: [0, 0, 0, 0, 0],
            },
          ],
        },
        statisticsOrderExpense: {
          series: [
            {
              name: new Date().getFullYear(),
              total: "00.000",
              data: [0, 0, 0, 0, 0],
            },
          ],
        },
        earningsChart: {
          total: 0,
          series: [0],
        },
        revenue: {
          years: [new Date().getFullYear()],
          price: "0",
          earning: '0',
          expense: '0',
          budget: "0",
          revenueReport: {
            series: [
              {
                name: "Earning",
                data: [0,0,0,0,0,0,0,0,0,0,0,0],
              },
              {
                name: "Expense",
                data: [0,0,0,0,0,0,0,0,0,0,0,0],
              },
            ],
          },
          budgetChart: {
            series: [
              {
                data: [0,0,0,0,0,0,0,0,0,0,0,0],
              },
              {
                data: [0,0,0,0,0,0,0,0,0,0,0,0],
              },
            ],
          },
        },
      },
    };
  },
  async created() {
    setTimeout(this.getData(), 500); 
  },
  methods:{
    async getData(){
      const result = await axios.get(
      "https://management-projects.herokuapp.com/api/dashboard"
    );
    const { data } = result;
    this.data.statisticsUsers[0].title = data.prospects;
    this.data.statisticsUsers[1].title = data.customers;
    this.data.statisticsUsers[2].title = data.suppliers;
    this.data.statisticsProducts[0].title = data.products;
    this.data.statisticsProducts[1].title = data.categories;
    this.data.statisticsProducts[2].title = data.subCategories;
    this.data.statisticsSales[0].title = data.salesQuotations;
    this.data.statisticsSales[1].title = data.salesCommands;
    this.data.statisticsSales[2].title = data.salesBills;
    this.data.statisticsShop[0].title = data.purchaseQuotations;
    this.data.statisticsShop[1].title = data.purchaseCommands;
    this.data.statisticsShop[2].title = data.purchaseBills;

    this.data.statisticsOrderEarning.series[0].total = data.earnings;
    var lastFiveEarning = data.monthlyEarnings.slice(-5);
    lastFiveEarning.forEach(element => {
      this.data.statisticsOrderEarning.series[0].data.push(element.total)
    });

    this.data.statisticsOrderExpense.series[0].total = data.expenses; 
     var lastFiveExpense = data.monthlyExpenses.slice(-5);   
    lastFiveExpense.forEach(element => {
      this.data.statisticsOrderExpense.series[0].data.push(element.total)
    });

    this.data.revenue.price = data.earnings - data.expenses;
        this.data.revenue.earning = data.earnings
    this.data.revenue.expense =  data.expenses;
    const thisYear = new Date().getFullYear();
    this.data.revenue.revenueReport.series[0].data = [];
    this.data.revenue.revenueReport.series[1].data = [];
    this.data.revenue.budgetChart.series[0].data = [];
    this.data.revenue.budgetChart.series[1].data = [];
    for (let index = 1; index < 13; index++) {
      let currentEarning = data.monthlyEarnings.filter(e => e.month == index && e.year == thisYear)
      if (currentEarning.length > 0) {
        this.data.revenue.revenueReport.series[0].data.push(currentEarning[0].total);
        this.data.revenue.budgetChart.series[0].data.push(currentEarning[0].total);
      } else {
        this.data.revenue.revenueReport.series[0].data.push(100);
        this.data.revenue.budgetChart.series[0].data.push(100);
      }
      let currentExpense = data.monthlyExpenses.filter(e => e.month == index && e.year == thisYear)
      if (currentExpense.length > 0) {
        this.data.revenue.revenueReport.series[1].data.push(currentExpense[0].total);
        this.data.revenue.budgetChart.series[1].data.push(currentExpense[0].total);
      } else {
        this.data.revenue.revenueReport.series[1].data.push(-100);
        this.data.revenue.budgetChart.series[1].data.push(-100);
      }      
    }
    }
  }
};
</script>

<style lang="scss">
@import "@core/scss/vue/pages/dashboard-ecommerce.scss";
@import "@core/scss/vue/libs/chart-apex.scss";
@import "@core/scss/vue/libs/map-leaflet.scss";

.vue2leaflet-map {
  &.leaflet-container {
    height: 350px;
  }
}
.leaflet-image-layer,
.leaflet-layer,
.leaflet-marker-icon,
.leaflet-marker-shadow,
.leaflet-pane,
.leaflet-pane > canvas,
.leaflet-pane > svg,
.leaflet-tile,
.leaflet-tile-container,
.leaflet-zoom-box {
  position: absolute !important;
  top: 0 !important;
}
.leaflet-pane {
  z-index: 400;
}
[dir="ltr"] .leaflet-image-layer,
[dir="ltr"] .leaflet-layer,
[dir="ltr"] .leaflet-marker-icon,
[dir="ltr"] .leaflet-marker-shadow,
[dir="ltr"] .leaflet-pane,
[dir="ltr"] .leaflet-pane > canvas,
[dir="ltr"] .leaflet-pane > svg,
[dir="ltr"] .leaflet-tile,
[dir="ltr"] .leaflet-tile-container,
[dir="ltr"] .leaflet-zoom-box {
  left: 0;
}
</style>